// extracted by mini-css-extract-plugin
var _1 = "t2l";
var _2 = "t2k";
var _3 = "t2j";
var _4 = "t2i";
export { _1 as "close", _2 as "code", _3 as "message", _4 as "title" }
